import { render, staticRenderFns } from "./PatientAlertType.vue?vue&type=template&id=1e5fa20a&"
import script from "./PatientAlertType.vue?vue&type=script&lang=js&"
export * from "./PatientAlertType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports